import { Chart, ArcElement } from "chart.js";

Chart.register(ArcElement);
